import React from 'react';
import Routes from '@routes';
import { I18nextProvider } from 'react-i18next';
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary';
import { SessionProvider } from '@contexts/SessionContextProvider';
import { i18nInstance } from '@utils/i18n';
import Layout from '@components/Layout';

function App() {
  return (
    <ErrorBoundary>
      <I18nextProvider i18n={i18nInstance}>
        <SessionProvider>
          <Layout>
            <Routes />
          </Layout>
        </SessionProvider>
      </I18nextProvider>
    </ErrorBoundary>
  );
}

export default App;
